import { render } from "./1.Categories.vue?vue&type=template&id=42e4566e&scoped=true"
import script from "./1.Categories.vue?vue&type=script&lang=js"
export * from "./1.Categories.vue?vue&type=script&lang=js"

import "./1.Categories.vue?vue&type=style&index=0&id=42e4566e&scoped=true&lang=css"
import "./1.Categories.vue?vue&type=style&index=1&id=42e4566e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42e4566e"]])

export default __exports__